export const UICustomElement = (tag_name: string) => (cls: { new(...args: any[]): HTMLElement }) => {
    window.customElements.define(tag_name, cls);
}
